export const links = {
  defaultThumb:
    "https://res.cloudinary.com/df3ajcohw/image/upload/v1640130834/assets/h2ohfs1vk3e7cazyo8kv.png",
};
